import { DateRangeValueType } from '@core/date-range-types';
import {
  ReportDashboardComponent,
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
} from '@core/reports-types';
import { SortDirection } from '@core/search-types';
export const mockReportsComponentCandidates: ReportDashboardComponent = {
  chartType: null,
  dateField: {
    field: 'created_at',
    resource: 'candidates',
  },
  dateFilter: {
    dateRange: DateRangeValueType.AllTime,
    dateStart: null,
    dateEnd: null,
  },
  description: null,
  endPoint: null,
  filters: [],
  generated: false,
  grid: {
    cols: 6,
    rows: 2,
    x: 0,
    y: 0,
  },
  id: 39468558,
  isAvailable: true,
  kind: <ReportDashboardComponentKind>'breakdown',
  localId: '44867ff2-6511-47cf-bf1c-4a56ab121ff8',
  metric: 'candidates',
  name: 'Published jobs',
  options: {
    includeArchivedJobs: true,
    includeArchivedRequisitions: true,
    includeDeletedCandidates: false,
    showAllData: false,
  },
  origin: 'template',
  primaryGroup: null,
  secondaryGroup: null,
  settings: {
    amountOfDataDisplayed: -1,
    localSortBy: null,
    localSortOrder: null,
  },
  sortBy: 'count',
  sortOrder: <SortDirection>'desc',
  startPoint: null,
  templateId: 'published_jobs',
  unavailableReason: null,
  viewMode: <ReportDashboardComponentViewMode>'summary',
};
